import { render, staticRenderFns } from "./stepTwoItem.vue?vue&type=template&id=84797e96&scoped=true"
import script from "./stepTwoItem.vue?vue&type=script&lang=js"
export * from "./stepTwoItem.vue?vue&type=script&lang=js"
import style0 from "./stepTwoItem.vue?vue&type=style&index=0&id=84797e96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84797e96",
  null
  
)

export default component.exports